module.exports = __webpack_public_path__ + "img/tab-11.7c9266e8.png";